import $axios from './axios'
import { apilists } from './apilists'

export const $request = {
    async getUserInfos(data) {
        let url = apilists.getUserInfos.url;
        return await $axios.request({
            method: apilists.getUserInfos.method,
            ...data
          }, url);
    },
    async checkLoginStatus(data) {
        let url = apilists.checkLoginStatus.url;
        return await $axios.request({
            method: apilists.checkLoginStatus.method,
            ...data
          }, url);
    },
    async aiCreateResume(data) {
        let url = apilists.aiCreateResume.url;
        return await $axios.request({
            method: apilists.aiCreateResume.method,
            ...data
          }, url);
    },
    async createResumeV2 (data) {
        let url = apilists.createResumeV2.url;
        return await $axios.request({
            method: apilists.createResumeV2.method,
            ...data
          }, url);
    },
    async saveResumePDF2Server (data, url, isFormData = false) {
        let requestUrl = apilists.saveResumePDF2Server.url;
        return await $axios.request({
            method: apilists.saveResumePDF2Server.method,
            ...data
          }, requestUrl, isFormData);
    },
    async getResumeV2List (data) {
        let url = apilists.getResumeV2List.url;
        return await $axios.request({
            method: apilists.getResumeV2List.method,
            ...data
          }, url);
    },
    async updateResumeV2 (data) {
        let url = apilists.updateResumeV2.url;
        return await $axios.request({
            method: apilists.updateResumeV2.method,
            ...data
          }, url);
    },
    async deleteResumeV2 (data) {
        let url = apilists.deleteResumeV2.url;
        return await $axios.request({
            method: apilists.deleteResumeV2.method,
            ...data
          }, url);
    },
    async getUserStoreTemp(data) {
        let url = apilists.getUserStoreTemp.url;
        return await $axios.request({
            method: apilists.getUserStoreTemp.method,
            ...data
          }, url);
    },
    async updateUserStoreTemplate(data) {
        let url = apilists.updateUserStoreTemplate.url;
        return await $axios.request({
            method: apilists.updateUserStoreTemplate.method,
            ...data
          }, url);
    },
    async aiOptimizeText(data) {
        let url = apilists.aiOptimizeText.url;
        return await $axios.request({
            method: apilists.aiOptimizeText.method,
            ...data
          }, url);
    },
    async resumeDownload(data) {
        let url = apilists.resumeDownload.url;
        return await $axios.request({
            method: apilists.resumeDownload.method,
            ...data
          }, url);
    },
}